konnyScript(function($){
    $('.bibFreeEvent').click(function(){
        $('.bibFreePopUp').addClass('active');
        $('body').addClass('popOpen');
    });
    $('.bibFreePopUp .bgLayer').click(function(){
        $('.bibFreePopUp').removeClass('active');
        $('body').removeClass('popOpen');
    });
    $('.bibFreePopUp .closeBt').click(function(){
        $('.bibFreePopUp').removeClass('active');
        $('body').removeClass('popOpen');
    });
    
    $('.qnaInfo header').click(function(){
    	$(this).toggleClass('active');
    });
    
    //온에어예정 제품 클릭 방지
    document.querySelectorAll('#knPrd26FW .gallerySlide a.release').forEach(function (a) {
    a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    }, true);
    });
    
    //몰컷 슬라이드_25FW
    $('[id^="mall_26ss_swiper_slide"]').each(function(index){
        var slideScr = this.querySelector('.swiper-scrollbar');
        var mallSlide = new Swiper(this,{
            slidesPerView:'auto',
            slidesPerGroup:1,
            spaceBetween:10,
            centeredSlides:false,
            scrollbar:{
                el:slideScr,
            },
        });
    });

    /* gif 슬라이드 */
    $('[id^="bgGif_swiper_slide"]').each(function(index){
        var gifSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed:0,
            autoplay:{
                delay:600,
                disableOnInteraction:false,
            },
        });
    });
    
    /* 스트랩 사용법 슬라이드 */
    $('[id^=\'stap_use_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage = this.querySelector('.swiper-pagination');
        var slideScr = this.querySelector('.swiper-scrollbar');
        var stapUseSlide = new Swiper(this, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            loop: true,
            speed: 0,
            autoplay: false, // Swiper 내장 autoplay 모듈은 사용하지 않고 아래에서 직접 제어
            pagination: {
                el: slidePage,
                clickable: true,
            },
        });

        // ---- 자동 롤링 직접 제어 (Swiper 내장 autoplay + speed:0 조합 버그 회피) ----
        var autoplayDelay = 1200;
        var autoplayTimer = null;

        function startAutoplay() {
            stopAutoplay();
            autoplayTimer = setInterval(function () {
                stapUseSlide.slideNext();
            }, autoplayDelay);
        }

        function stopAutoplay() {
            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        }

        startAutoplay();

        // 사용자가 스와이프(터치)한 뒤에도 자동 롤링 재시작
        stapUseSlide.on('touchEnd', function () {
            startAutoplay();
        });

        // 페이지네이션 클릭 등으로 슬라이드가 바뀐 경우에도 재시작
        stapUseSlide.on('slideChangeTransitionEnd', function () {
            startAutoplay();
        });
    });

    function adjustThumbPosition(swiper, activeIndex) {
        const total = swiper.slides.length;
        if (total <= 3) return;

        if (activeIndex <= 1) {
            swiper.slideTo(0, 300);
            return;
        }

        if (activeIndex >= total - 2) {
            swiper.slideTo(total - 3, 300);
            return;
        }

        swiper.slideTo(activeIndex - 1, 300);
    }

    function initProductGallery(scope) {

        if (typeof Swiper === 'undefined') {
            console.log('Swiper not loaded');
            return;
        }

        scope.querySelectorAll('.prdGallery').forEach(function (gallery) {

            if (gallery.dataset.swiperInit === "true") return;
            gallery.dataset.swiperInit = "true";

            const thumbEl = gallery.querySelector('.prdGalleryThumb');
            const mainEl  = gallery.querySelector('.prdGalleryMain');

            if (!thumbEl) return;

            // 🔥 슬라이드 개수 체크
            const slideCount = thumbEl.querySelectorAll('.swiper-slide').length;
            const scrollbarEl = thumbEl.querySelector('.swiper-scrollbar');

            const thumbs = new Swiper(thumbEl, {
                slidesPerView: 3.45,
                spaceBetween: 10,
                watchSlidesProgress: true,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                scrollbar: slideCount > 3 ? {
                    el: scrollbarEl,
                    draggable: true,
                    hide: false,
                } : false,
            });

            // 🔥 3개 이하일 경우 스크롤바 숨김
            if (slideCount <= 3 && scrollbarEl) {
                scrollbarEl.style.display = 'none';
            }

            if (mainEl) {
                const main = new Swiper(mainEl, {
                    speed: 300,
                    loop: false,
                    observer: true,
                    observeParents: true,
                    thumbs: {
                        swiper: thumbs,
                    },
                    on: {
                        slideChange: function () {
                            adjustThumbPosition(thumbs, this.activeIndex);
                        }
                    }
                });
            }

            thumbs.on('click', function () {
                if (thumbs.clickedIndex == null) return;
                adjustThumbPosition(thumbs, thumbs.clickedIndex);
            });

        });
    }

    window.addEventListener('load', function () {
        initProductGallery(document);
    });

    document.addEventListener('shopify:section:load', function (e) {
        initProductGallery(e.target);
    });

});

/* ── 26SS 몰컷 슬라이더 (KR detail_kn26ss-slider.js 이식) ──
 * .kn26ss-slider = 카페24 26SS PDP를 해외로 변환한 슬라이더 (pagination bullets)
 * 기존 mall_26ss_swiper_slide(scrollbar) 로직과 분리 위해, 변환 HTML에서 id 제거 필수
 * data-* 옵션: slides-per-view("auto"|num) / space-between(num) / centered-slides,
 *   centered-slides-bounds, slide-to-clicked-slide, loop("true"|"false")
 */
(() => {
	const parseBool = (value, fallback) => {
		if (value === undefined) return fallback;
		return value === "true";
	};

	const parseSlidesPerView = (value) => {
		if (value === undefined || value === "auto") return "auto";
		const parsed = parseFloat(value);
		return Number.isNaN(parsed) ? "auto" : parsed;
	};

	const parseNumber = (value, fallback) => {
		if (value === undefined) return fallback;
		const parsed = parseFloat(value);
		return Number.isNaN(parsed) ? fallback : parsed;
	};

	const initKn26ssSliders = (scope) => {
		if (typeof Swiper === "undefined") {
			setTimeout(() => initKn26ssSliders(scope), 50);
			return;
		}

		scope.querySelectorAll(".kn26ss-slider").forEach((el) => {
			if (el.swiper) return;

			const data = el.dataset;

			new Swiper(el, {
				observer: true,
				observeParents: true,
				slidesPerView: parseSlidesPerView(data.slidesPerView),
				spaceBetween: parseNumber(data.spaceBetween, 10),
				centeredSlides: parseBool(data.centeredSlides, true),
				centeredSlidesBounds: parseBool(data.centeredSlidesBounds, true),
				slideToClickedSlide: parseBool(data.slideToClickedSlide, true),
				loop: parseBool(data.loop, false),
				pagination: {
					el: el.querySelector(".swiper-pagination"),
					type: "bullets",
					clickable: true,
				},
			});
		});
	};

	const initKn26ssTabs = (scope) => {
		scope.querySelectorAll(".kn26ss-color-tabs").forEach((tabEl) => {
			if (tabEl.dataset.kn26ssTabInit === "true") return;
			tabEl.dataset.kn26ssTabInit = "true";

			const buttons = tabEl.querySelectorAll("[data-tab-buttons] > li");
			const panels = tabEl.querySelectorAll("[data-tab-panels] > li");

			if (!buttons.length || buttons.length !== panels.length) return;

			buttons.forEach((btn, index) => {
				btn.addEventListener("click", () => {
					buttons.forEach((b) => b.classList.remove("on"));
					panels.forEach((p) => p.classList.remove("on"));
					btn.classList.add("on");
					panels[index].classList.add("on");
				});
			});
		});
	};

	const initKn26ss = (scope) => {
		initKn26ssSliders(scope);
		initKn26ssTabs(scope);
	};

	const ready = (fn) => {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", fn);
		} else {
			fn();
		}
	};

	ready(() => initKn26ss(document));
	document.addEventListener("shopify:section:load", (e) => initKn26ss(e.target));
})();